<div class="container">
  <div class="w-tabs">
    <mat-tab-group>
      <mat-tab [label]="'ORDERS.ALLORDERS' | translate">
        <div class="orders-container">
          <div class="order-box w-depth" *ngFor="let order of orders">
            <div class="flex-container">
              <div class="order-details">
                <div class="order-status">
                  <div class="status-box">
                    {{'ORDERSTATUS.'+orderStatuses[order?.status] | translate}}
                  </div>
                  <div class="delivery-hour">
                    {{order.deliveryDate | momentCalendar}}
                    <span *ngIf="order.deliveryHour">{{dayHours[order.deliveryHour.toLowerCase()]}}</span>
                  </div>
                  <div class="order-number">
                    Order &#35;{{order?.orderNumber}}
                  </div>
                </div>
                <div class="other-details">
                  <div class="fuel-name">
                    {{order?.specs?.product?.name}}
                  </div>
                  <div class="address">
                    {{order?.fullAddress}}
                  </div>
                  <div class="amount">
                    {{order?.specs?.recipient?.type}}
                  </div>
                  <div class="amount">
                    {{order?.totals.amount}} {{'GALLONS' | translate}}
                  </div>
                </div>
                <div class="total">
                  {{'TOTAL' | translate}}: {{order.totals.total | toFixNumber | currency}}
                </div>
              </div>
              <div class="order-actions">
                <a [routerLink]="'/account/orders/details/' + order.id" class="w-btn orange-btn btn-wave"
                   *ngIf="order.status < 5 || order.status == 9">
                  {{'ORDERS.TRACK' | translate}}
                </a>
                <a class="w-btn light-blue-btn btn-wave" *ngIf="order.status >= 5 && false">
                  {{'ORDERS.REORDER' | translate}}
                </a>
                <div class="bottom-btns">
                  <a class="w-btn grey-btn btn-wave" [routerLink]="'/account/orders/info/' + order.id"
                     *ngIf="order.status != 5">
                    {{'ORDERS.DETAILS' | translate}}
                  </a>
                  <a class="w-btn grey-btn btn-wave" [routerLink]="'/account/orders/receipt/' + order.id"
                     *ngIf="order.status == 5">
                    <span>{{'ORDERS.RECEIPT' | translate}}</span>
                  </a>
                  <a class="w-btn grey-btn btn-wave" href="https://wahii.com/faq.html" target="_blank">{{'ORDERS.HELP' | translate}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="no-orders" *ngIf="!orders?.length && !showLoader">{{'ORDERS.NOORDERS' | translate}}</div>
          <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
        </div>
      </mat-tab>
      <mat-tab [label]="'ORDERS.UPCOMING' | translate">
        <div class="orders-container">
          <div class="order-box w-depth" *ngFor="let order of upcomingOrders">
            <div class="flex-container">
              <div class="order-details">
                <div class="order-status">
                  <div class="status-box">
                    {{'ORDERSTATUS.'+orderStatuses[order?.status] | translate}}
                  </div>
                  <div class="delivery-hour">
                    {{order.deliveryDate | momentCalendar}}
                    <span *ngIf="order.deliveryHour">{{dayHours[order.deliveryHour.toLowerCase()]}}</span>
                  </div>
                  <div class="order-number">
                    Order &#35;{{order?.orderNumber}}
                  </div>
                </div>
                <div class="other-details">
                  <div class="fuel-name">
                    {{order?.specs?.product?.name}}
                  </div>
                  <div class="address">
                    {{order?.fullAddress}}
                  </div>
                  <div class="amount">
                    {{order?.specs?.recipient?.type}}
                  </div>
                  <div class="amount">
                    {{order?.specs?.product?.amount}} {{'GALLONS' | translate}}
                  </div>
                </div>
                <div class="total">
                  {{'TOTAL' | translate}}: {{order.totals.total | toFixNumber | currency}}
                </div>
              </div>
              <div class="order-actions">
                <a [routerLink]="'/account/orders/details/' + order.id" class="w-btn orange-btn btn-wave"
                   *ngIf="order.status < 5">
                  {{'ORDERS.TRACK' | translate}}
                </a>
                <a class="w-btn light-blue-btn btn-wave" *ngIf="order.status >= 5 && false">
                  {{'ORDERS.REORDER' | translate}}
                </a>
                <div class="bottom-btns">
                  <a class="w-btn grey-btn btn-wave" [routerLink]="'/account/orders/info/' + order.id"
                     *ngIf="order.status != 5">
                    {{'ORDERS.DETAILS' | translate}}
                  </a>
                  <a class="w-btn grey-btn btn-wave" [routerLink]="'/account/orders/receipt/' + order.id"
                     *ngIf="order.status == 5">
                    <span>{{'ORDERS.RECEIPT' | translate}}</span>
                  </a>
                  <a class="w-btn grey-btn btn-wave" href="https://wahii.com/faq.html" target="_blank">{{'ORDERS.HELP' | translate}}</a>
                </div>
              </div>
            </div>
          </div>
          <div class="no-orders" *ngIf="!upcomingOrders?.length && !showLoader">{{'ORDERS.NOORDERS' | translate}}</div>
          <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
